import styles from '@/styles/hottest-deals/hotSchema.module.scss'
import Image from 'next/image'
import Link from 'next/link'

import GoodsComponentWithDiscountNew from '@/components/GoodsComponentWithDiscountNew'
import { Button } from 'antd'

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

interface ProductItem {
  productID: string;
  name: string;
  url: string;
  imgUrl: string;
  reviewCount: number;
  price: number;
  normalPrice: number;
  freeShipping: number;
  onSale: number;
  reduced: number;
  isNew: number;
  position?: number,
  location?: string;
  isEmailOnly: any,
  promotionTypeID: string | number;
  promotion: {
    productID: number;
    promotionType: number;
    promotionPrice: number;
    normalPrice: number;
    endDate: string;
    status: number;
    notified: number;
    pointRate: string;
    promotionRate: number;
  };
  review: {
    avgRank: number;
    total: number;
  };
}

interface HotSchemaItem {
  itemID: number;
  name: string;
  title: string;
  extraTitle: string;
  isEnable: number;
  url: string;
  logoUrl: string;
  items: ProductItem[]
}

interface HotSchemaProps {
  hotSchemaData: HotSchemaItem[];
}

export default function HotSchema(props: HotSchemaProps) {

  const fullItemData = props.hotSchemaData[0]

  return (
    <>
      <div className={styles['hot-schema-box']}>
        <Image
          className={styles['hot-schema-banner']}
          src={`${imageDomain}/hottest-deals/hot-deals.png`}
          alt={'hot schema banner'}
          width={1200}
          height={70}></Image>

        <div className={styles['schema-content']}>
          <div className={styles['full-item']}>
            <Link href={fullItemData.url} legacyBehavior>
              <a>
                <div className={styles['item-banner-box']}>
                  <Image
                    className={styles['item-banner']}
                    src={fullItemData.logoUrl}
                    alt={fullItemData.name}
                    width={1200}
                    height={239}></Image>
                </div>
              </a>
            </Link>

            <div className={styles['product-box']}>
              {
                !!(fullItemData.items && fullItemData.items.length) &&
                fullItemData.items.map((product: ProductItem, index:number) => (
                  <div className={styles['product-item']} key={index}>
                    <GoodsComponentWithDiscountNew {...{ ...product, productName: product.name, imgUrl: product.imgUrl }} />
                  </div>
                ))
              }
            </div>

            <div className={styles['title-box']}>
              <Link href={fullItemData.url} legacyBehavior>
                <a>
                  <div className={styles['title-content']}>
                    <div className={styles['title']}>{ fullItemData.title }</div>
                    <div className={styles['description']}>{ fullItemData.extraTitle }</div>
                  </div>
                </a>
              </Link>

              <div className={styles['btn-box']}>
                <Button 
                  href={fullItemData.url}
                  type="primary"
                  style={{backgroundColor: "#e6415f"}}
                >
                  See More &gt;
                </Button>
              </div>
            </div>
          </div>

          <div className={styles['columns-item-box']}>
            {
              props.hotSchemaData.slice(1).map((item: HotSchemaItem, index: number) => (
                <div className={styles['columns-item']} key={index}>
                  <Link href={item.url} legacyBehavior>
                    <a>
                      <Image
                        className={styles['item-banner']}
                        src={item.logoUrl}
                        alt={item.name}
                        width={1200}
                        height={239}></Image>
                    </a>
                  </Link>

                  <div className={styles['product-box']}>
                    {
                      !!(item.items && item.items.length) &&
                      item.items.map((product: ProductItem) => (
                        <div className={styles['product-item']} key={product.productID}>
                          <GoodsComponentWithDiscountNew {...{ ...product, productName: product.name, imgUrl: product.imgUrl, hiddenReviews: true }} />
                        </div>
                      ))
                    }
                  </div>

                  <div className={styles['title-box']}>
                    <Link href={item.url} legacyBehavior>
                      <a>
                        <div className={styles['title-content']}>
                          <div className={styles['title']}>{ item.title }</div>
                          <div className={styles['description']}>{ item.extraTitle }</div>
                        </div>
                      </a>
                    </Link>

                    <div className={styles['btn-box']}>
                      <Button 
                        href={item.url}
                        type="primary"
                        style={{backgroundColor: "#e6415f"}}
                      >
                        See More &gt;
                      </Button>
                    </div>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </>
  )
}